import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { getViewId } from '../../selectors';
import { trackPageLoadDiagnostic } from '../logging/trackPageLoadDiagnostic';

export const usePageLoadDiagnostic = () => {
  const viewId = useSelector(getViewId);
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!hasFiredRef.current && viewId) {
      trackPageLoadDiagnostic(viewId);
      hasFiredRef.current = true;
    }
  }, [viewId]);
};
